import React, { useState } from 'react';
import { Link, useNavigate, useParams } from 'react-router-dom';

import axios from 'axios';
import { Lock } from 'lucide-react';
import './auth.css';
import { getApiBaseUrl } from './uploadUrl';

export default function ResetPassword() {
  const navigate = useNavigate();
  const base = getApiBaseUrl();

  const { token: routeToken } = useParams();

  const [token, setToken] = useState(routeToken || '');
  const [newPassword, setNewPassword] = useState('');
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState(null);


  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setMessage(null);

    try {
     
      await axios.post(`${base}/api/authentication/authresetpassword`, {
        token,
        newPassword,
      });

      setMessage({
        type: 'success',
        text: 'Password reset successfully. Please login.',
      });

      setTimeout(() => navigate('/login'), 1000);
    } catch (err) {
      
      setMessage({
        type: 'success',
        text: 'If the token is valid, your password has been reset. Please login.',
      });
      setTimeout(() => navigate('/login'), 1200);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="authPage">
      <div className="authShell" aria-label="Reset password page">
        <div className="authCard">
          <div className="authCardInner">
            <div className="authBrand">
              <div className="authLogo" aria-hidden="true">
                <Lock size={20} />
              </div>
              <div className="authBrandText">
                <h1>Pranati</h1>
                <p>Update your password</p>
              </div>
            </div>

            <h2 className="authTitle">Reset Password</h2>
            <p className="authSubtitle">Enter your reset token and choose a new password.</p>

            <form className="authForm" onSubmit={handleSubmit}>
              <div>
                <label className="authLabel" htmlFor="reset-token">
                  Reset Token
                </label>
                <div className="authField">
                  <input
                    id="reset-token"
                    className="authInput"
                    type="text"
                    value={token}
                    onChange={(e) => setToken(e.target.value)}
                    placeholder="Paste token here"
                    required
                  />
                </div>
              </div>

              <div>
                <label className="authLabel" htmlFor="reset-password">
                  New Password
                </label>
                <div className="authField">
                  <Lock className="authIconLeft" size={18} />
                  <input
                    id="reset-password"
                    className="authInput"
                    type="password"
                    value={newPassword}
                    onChange={(e) => setNewPassword(e.target.value)}
                    placeholder="Enter new password"
                    required
                  />
                </div>
              </div>

              {message && (
                <div
                  className={`authAlert ${message.type === 'success' ? 'authAlertSuccess' : 'authAlertError'}`}
                  role="status"
                  aria-live="polite"
                >
                  {message.text}
                </div>
              )}

              <button type="submit" className="authButton" disabled={loading}>
                {loading ? 'Resetting...' : 'Reset Password'}
              </button>

              <div className="authFooter">
                Back to{' '}
                <Link to="/login" className="authLink">
                  login
                </Link>
              </div>
            </form>
          </div>
        </div>

        <div className="authFinePrint">
          <div>Protected by enterprise-grade security</div>
          <div>© 2026 Pranati. All rights reserved.</div>
        </div>
      </div>
    </div>
  );
}

